<template>
  <div class="container search">
    <search :tags="tags" :kwd="kwd" :id="id"></search>
    <tags :tags="tags" :kwd="kwd" :id="id"></tags>
  </div>
</template>
<script>
// import cutTool from 'nodejieba'
import tags from './tags.vue'
import search from './search.vue'
export default {
  data () {
    return {
      keywords: this.kwd
    }
  },
  components: {
    search,
    tags
  },
  props: ['kwd', 'id'],
  computed: {
    tags () {
      return this.$store.state.tags
    }
  }
}
</script>
<style scoped lang='sass'>

.search
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  margin-bottom: 30px
  +mobile
    margin-bottom: 15px
</style>
